import React, { ReactNode } from 'react';
import {
  Box,
  FormHelperText,
  InputLabel,
  Select as MuiSelect,
  SelectProps as MuiSelectProps,
} from '@mui/material';

import { LabelPanel } from './LabelPanel';

export type SelectProps<Value = unknown> = {
  endLabel?: ReactNode;
  helperText?: ReactNode;
  selectStyleProps?: Pick<MuiSelectProps, 'sx' | 'className' | 'style'>;
} & MuiSelectProps<Value>;

export function Select<Value>({
  label,
  endLabel,
  disabled,
  helperText,
  children,
  sx,
  style,
  className,
  selectStyleProps,
  ...props
}: SelectProps<Value>) {
  const isActiveLabel = Boolean(label || endLabel);
  const { error } = props;

  return (
    <Box sx={sx} className={className} style={style}>
      {isActiveLabel && (
        <InputLabel id={props.id}>
          <LabelPanel label={label} endLabel={endLabel} disabled={disabled} />
        </InputLabel>
      )}

      <MuiSelect<Value>
        label={label}
        sx={{ width: '100%', padding: 0 }}
        variant="standard"
        disabled={disabled}
        {...selectStyleProps}
        {...props}
      >
        {children}
      </MuiSelect>

      {helperText && (
        <FormHelperText error={error}>{helperText}</FormHelperText>
      )}
    </Box>
  );
}
